import { Pipe, PipeTransform } from '@angular/core';
// Importación de Angular Fire 2
import { AngularFireDatabase } from 'angularfire2/database'
import { IndicadoresPagosService } from '../../services/business-logic/indicadores-pagos.service';
@Pipe({
  name: 'filtrarPagos',
  // impure a propósito: listaGeneralPagos/listaPagosRechazados se mutan con .push() en vez de
  // reasignarse. Un pipe puro solo re-evalúa cuando la referencia del array cambia, así que con
  // .push() nunca vuelve a correr — *ngFor queda pegado al primer resultado (vacío). Ver TOM-388.
  pure: false
})
export class FiltrarPagosPipe implements PipeTransform {

    constructor(public af:AngularFireDatabase, private indicadoresPagosService: IndicadoresPagosService){}
    transform(arregloPagos:any, formaPago:any, estatus:any,idServicio): any {
        if(!arregloPagos){
            return arregloPagos;
        }
        return arregloPagos.filter(pago => this.indicadoresPagosService.filtroPago(pago, formaPago, estatus, idServicio));
    }
}

/* Por ID

    let arregloNuevo=[];
    if(terminoBuscar == undefined || terminoBuscar =='' ||estatusBuscar == undefined || estatusBuscar ==''|| idBuscar == undefined || idBuscar =='')
        return arreglo
    else {
        for (var indice in arreglo) {
            if(arreglo[indice].confirmacionIdTrosten.toLowerCase().indexOf(terminoBuscar.toLowerCase()) > -1){
                arregloNuevo.push(arreglo[indice])
            }
        }
    }
    return arregloNuevo
*/


/* Por estatus
 // Arreglo de unidades que se van a mostrar
        let pagosFiltroEstatus:any = [];
        // Hace un loop por las unidades proporcionados para poder filtrarlos por id de operador
        if(id == ''){
            pagosFiltroEstatus= arregloPagos
        }else{
            arregloPagos.forEach(pago => {
                if(pago.estatus == id)
                    pagosFiltroEstatus.push(pago)
            });
        }
        return pagosFiltroEstatus;
*/



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/shared/pipes/filtrar-pagos.pipe.ts